/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProdcomExportXlsxRequest } from '../models/ProdcomExportXlsxRequest';
import type { ProdcomFactsByCodesRequest } from '../models/ProdcomFactsByCodesRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ProdcomService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List PRODCOM reporters
     * @returns any Successful Response
     * @throws ApiError
     */
    public listProdcomCountriesApiV1ProdcomCountriesGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/prodcom/countries',
        });
    }
    /**
     * List PRODCOM reporters
     * @returns any Successful Response
     * @throws ApiError
     */
    public listProdcomCountriesApiV1ProdcomCountriesGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/prodcom/countries',
        });
    }
    /**
     * List available PRODCOM fact years
     * @returns any Successful Response
     * @throws ApiError
     */
    public listProdcomFactYearsApiV1ProdcomFactYearsGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/prodcom/fact-years',
        });
    }
    /**
     * List available PRODCOM fact years
     * @returns any Successful Response
     * @throws ApiError
     */
    public listProdcomFactYearsApiV1ProdcomFactYearsGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/prodcom/fact-years',
        });
    }
    /**
     * List PRODCOM indicators
     * @returns any Successful Response
     * @throws ApiError
     */
    public listProdcomIndicatorsApiV1ProdcomIndicatorsGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/prodcom/indicators',
        });
    }
    /**
     * List PRODCOM indicators
     * @returns any Successful Response
     * @throws ApiError
     */
    public listProdcomIndicatorsApiV1ProdcomIndicatorsGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/prodcom/indicators',
        });
    }
    /**
     * Fetch PRODCOM facts for reporter/year/indicator and code set
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public getProdcomFactsByCodesApiV1ProdcomFactsByCodesPost(
        requestBody: ProdcomFactsByCodesRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/prodcom/facts/by-codes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Fetch PRODCOM facts for reporter/year/indicator and code set
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public getProdcomFactsByCodesApiV1ProdcomFactsByCodesPost1(
        requestBody: ProdcomFactsByCodesRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/prodcom/facts/by-codes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export PRODCOM observation table as XLSX
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public exportProdcomXlsxApiV1ProdcomExportXlsxPost(
        requestBody: ProdcomExportXlsxRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/prodcom/export-xlsx',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export PRODCOM observation table as XLSX
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public exportProdcomXlsxApiV1ProdcomExportXlsxPost1(
        requestBody: ProdcomExportXlsxRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/prodcom/export-xlsx',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
